import { render, staticRenderFns } from "./contractModel.vue?vue&type=template&id=c187a712&scoped=true"
import script from "./contractModel.vue?vue&type=script&lang=js"
export * from "./contractModel.vue?vue&type=script&lang=js"
import style0 from "./contractModel.vue?vue&type=style&index=0&id=c187a712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c187a712",
  null
  
)

export default component.exports